import { Component, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { AppService } from '@app/core/services/app.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';
import { Child } from '@app/shared/models/child';
import { Router } from '@angular/router';
import { Goal } from '@app/shared/models/form-profile';

@Component({
  selector: 'app-child-admin',
  imports: [TranslatePipe, MatIcon, MatButtonModule],
  templateUrl: './child-admin.component.html',
  styleUrl: './child-admin.component.scss',
})
export class ChildAdminComponent {
  private readonly appService = inject(AppService);
  private readonly router = inject(Router);

  protected readonly childrenSignal = this.appService.childrenSignal;
  protected readonly selectedChildIdSignal = this.appService.selectedChildIdSignal;
  protected readonly selectedChild = this.appService.selectedChild;
  protected readonly selectedChildForDeletion = signal<Child | undefined>(undefined);
  protected readonly overallGoals: Goal[] = [
    Goal.familyAndSocial,
    Goal.enjoyHealthyFood,
    Goal.reflectedDecisionsRegulatedEmotions,
    Goal.dailyJoyMoreInterest
  ];
  protected readonly currentSelectedMainGoal = signal<Goal | undefined>(undefined);

  @ViewChild('popoverDialogDelete') popoverDialogDelete!: ElementRef;

  protected onSelectChild(id: string) {
    this.appService.selectChild(id);
  }

  protected addAdditionalChild() {
    this.appService.selectChild(undefined);
    this.router.navigateByUrl('profile');
  }

  protected changeCurrentMainGoal(goal: Goal) {
    this.currentSelectedMainGoal.set(goal);
  }

  protected submitCurrentMainGoal() {
    const current = this.currentSelectedMainGoal();
    if (current) {
      this.appService.changeMainGoalOfSelectedChild(current);
    }
  }

  protected goToApp() {
    if (this.appService.firstStartSignal()) {
      this.router.navigateByUrl('tutorial');
    } else {
      this.router.navigateByUrl('exhibition');
    }
  }

  protected deleteChild() {
    this.appService.removeChild(this.selectedChildForDeletion().id);
    this.popoverDialogDelete?.nativeElement.hidePopover();

    if (this.childrenSignal()?.length > 0) {
      this.appService.selectChild(this.childrenSignal()[0].id);
    }
  }

  protected cancelChildDeletion() {
    // Close Dialog
    this.popoverDialogDelete?.nativeElement.hidePopover();
  }

  protected editChild(child: Child) {
    this.appService.selectChild(child.id);
    this.router.navigateByUrl('profile');
  }

  protected showDeleteChildDialog(child: Child) {
    this.selectedChildForDeletion.set(child);
    this.popoverDialogDelete?.nativeElement.showPopover();
  }

}
